"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Advert = exports.ADVERT_DATETIMES = exports.ADVERT_ON_UPDATE_IGNORE_PROPS = exports.ADVERT_STORY_ASSETS_FIELDS = exports.ADVERT_ASSETS_FIELDS = exports.ADVERT_BOOLEANS = exports.ADVERT_INTEGERS = exports.ADVERT_MODEL_VERSION = exports.ADVERT_TYPES = void 0;
const moment = require("moment");
const QuizData_1 = require("./QuizData");
const StoryData_1 = require("./StoryData");
const SearchData_1 = require("./SearchData");
const SharingData_1 = require("./SharingData");
const ToolData_1 = require("./ToolData");
const AutoPublishOptions_1 = require("./AutoPublishOptions");
const advert_mapper_1 = require("../mappers/advert.mapper");
const uniqid = require("uniqid");
const Target_1 = require("./Target");
exports.ADVERT_TYPES = ["post", "search", "story", "quiz", "tool", "notification", "video"];
exports.ADVERT_MODEL_VERSION = "latest";
exports.ADVERT_INTEGERS = [
    "weight", "maxViews",
];
exports.ADVERT_BOOLEANS = [
    "isFree", "published", "archived", "showReadMore", "isVideo", "promoteInSearch"
];
exports.ADVERT_ASSETS_FIELDS = [
    "logo", "image", "imageSmall",
];
exports.ADVERT_STORY_ASSETS_FIELDS = [
    "story.screens[%d].logo", "story.screens[%d].image",
];
exports.ADVERT_ON_UPDATE_IGNORE_PROPS = [
    "id", "label", "_$audiences", "_$map",
];
exports.ADVERT_DATETIMES = [
    "createdAt", "publishedAt", "unpublishedAt", "autoStartAt", "autoStopAt",
];
const RAND_NAMES = [
    "Xylopénine Abrigandal",
    "Asswiper Sergingue 34mg",
    "Chuknorris en cartouche",
    "Pensylvanie 2021/L",
    "Vandiesel 58mg",
    "Xylopénine Abrigandal",
    "Patrique Générique",
    "Allojaipadbatterie 45mg",
    "Marzipan Cake",
    "Sassinject 67L/Ui",
    "Audience de Vianney: Coco",
];
const imageFields = [
    "logo",
    "image",
    "imageSmall",
    "video"
];
class Advert {
    constructor(data) {
        this.id = null;
        this.name = RAND_NAMES[Math.floor(Math.random() * RAND_NAMES.length)];
        this.label = 'Advert';
        this.type = null;
        this.weight = 5;
        this.maxViews = 5;
        this.isFree = false;
        this.isSeen = false;
        this.published = false;
        this.archived = false;
        this.promoteInSearch = false;
        this.showReadMore = true;
        this.openIn = null;
        this.sonataId = null;
        this.pixelTrackingUrl = null;
        this.createdAt = null;
        this.updatedAt = null;
        this.publishedAt = null;
        this.unpublishedAt = null;
        this.autoStartAt = null;
        this.autoStopAt = null;
        this.quiz = new QuizData_1.QuizData();
        this.story = new StoryData_1.StoryData();
        this.search = new SearchData_1.SearchData();
        this.sharing = new SharingData_1.SharingData();
        this.tool = new ToolData_1.ToolData();
        this.logo = 'https://med-cdn.ams3.digitaloceanspaces.com/assets/clients/medics_assets/pastille.png';
        this.image = null;
        this.images = [];
        this.imageSmall = null;
        this.video = null;
        this.source = 'https://360medics.com/';
        this.author = null;
        this.title = null;
        this.subtitle = "Partenariat sponsorisé";
        this.tagline = null;
        this.description = null;
        this.footNote = "Vos données sont protégées. Aucune donnée nominative n’est partagée avec le partenaire.";
        this.buttonLabel = "Découvrir";
        this._model = null;
        this._$map = null;
        this._$audiences = [];
        this._$target = new Target_1.Target();
        this.autoPublishOptions = new AutoPublishOptions_1.AutoPublishOptions();
        this.adVersion = null;
        if (data) {
            if (Object.keys(data).length === 0) {
                throw new Error(`Advert.ts: data is provided but is an empty object. Did you try to hydray with empty req.body object?`);
            }
            if (typeof data._model === "undefined" || data._model !== exports.ADVERT_MODEL_VERSION) {
                data._model = null;
                const normalizedData = (0, advert_mapper_1.advertMapper)().map(data, '->', data);
                data = Object.assign({}, normalizedData);
            }
            else if (data._model === exports.ADVERT_MODEL_VERSION) {
                data = data;
            }
            else {
                const normalizedData = (0, advert_mapper_1.advertMapper)().map(data, '->', data);
                data = Object.assign({}, normalizedData);
            }
            this.hydrate(data);
            if (typeof data.audiences !== "undefined" && data.audiences !== null) {
                this._$audiences = data.audiences;
            }
        }
    }
    hydrate(data) {
        for (const prop in data) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                if (prop === 'quiz') {
                    this['quiz'] = new QuizData_1.QuizData(data[prop]);
                    if (typeof data.hasAnswered !== "undefined" && typeof data.answeredIds !== "undefined") {
                        this['quiz'].hasAnswered = data.hasAnswered;
                        if (null !== data.answeredIds) {
                            this['quiz'].answeredIds = data.answeredIds.split(";");
                        }
                        else {
                            this['quiz'].answeredIds = [];
                        }
                    }
                }
                else if (prop === 'story') {
                    this['story'] = new StoryData_1.StoryData(data[prop]);
                    this['story'].isSeen = data.isSeen;
                }
                else if (prop === 'search') {
                    this['search'] = new SearchData_1.SearchData(data[prop]);
                }
                else if (prop === 'sharing') {
                    this['sharing'] = new SharingData_1.SharingData(data[prop]);
                }
                else if (prop === 'tool') {
                    this['tool'] = new ToolData_1.ToolData(data[prop]);
                }
                else if (prop === 'autoPublishOptions') {
                    this['autoPublishOptions'] = new AutoPublishOptions_1.AutoPublishOptions(data[prop]);
                }
                else if (exports.ADVERT_DATETIMES.indexOf(prop) > -1) {
                    if (typeof data[prop] === "number") {
                        this[prop] = parseInt(`${data[prop]}`);
                    }
                    else {
                        try {
                            const datetime = moment(data[prop]);
                            if (!datetime.isValid()) {
                                this[prop] = null;
                            }
                            else {
                                this[prop] = (datetime.valueOf() / 1000);
                            }
                        }
                        catch (e) {
                            this[prop] = null;
                        }
                    }
                }
                else if (prop === 'images') {
                    if (!data[prop]) {
                        this[prop] = [];
                    }
                    else {
                        this[prop] = typeof data[prop] === "string"
                            ? JSON.parse(data[prop]).map(image => `${image.split('?d=')[0]}?d=${uniqid()}`)
                            : data[prop].map(image => `${image.split('?d=')[0]}?d=${uniqid()}`);
                    }
                }
                else if (imageFields.includes(prop)) {
                    if (data[prop]) {
                        this[prop] = `${data[prop].split('?d=')[0]}?d=${uniqid()}`;
                    }
                    if (prop === 'logo' && data.type === "notification" && !data.logo) {
                        this.logo = null;
                    }
                }
                else {
                    let value = data[prop];
                    if (exports.ADVERT_INTEGERS.indexOf(prop) > -1) {
                        value = parseInt(value);
                    }
                    if (exports.ADVERT_BOOLEANS.indexOf(prop) > -1) {
                        value = Advert.toBoolOrNull(value);
                    }
                    this[prop] = value;
                }
            }
        }
    }
    setUpdatedAt(value = null) {
        if (null === value) {
            this.updatedAt = Math.round(moment().valueOf() / 1000);
        }
        else {
            if (`${value}`.length === 10) {
                this.updatedAt = value;
            }
            else {
                throw new Error("Advert::setupdatedAt(<timestamp>) must be an epoch timestamp with 10 numbers. This feature will break in 2480");
            }
        }
    }
    static toBoolOrNull(value) {
        if (value === null) {
            return null;
        }
        switch (`${value}`.toLowerCase().trim()) {
            case "true":
            case "yes":
            case "1": return true;
            case "false":
            case "no":
            case "0":
            case null: return false;
            default: return Boolean(value);
        }
    }
}
exports.Advert = Advert;
Advert.NOW = null;
//# sourceMappingURL=Advert.js.map